var fuelCardsList = (function () {

    const init = function () {
        $('#fuel-cards-datatable').DataTable({
            "autoWidth": false,
            "stateSave": true,
            "order": [],
            "columnDefs": [
                { "orderable": false, "targets": 5 },
                { "className": 'serialNumberColumn', "targets": 0 },
                { "className": 'fuelDispensersCountColumn desktop', "targets": 1 },
                { "className": 'clientAccountColumn desktop', "targets": 2 },
                { "className": 'typeColumn desktop', "targets": 3 },
                { "className": 'stateColumn desktop', "targets": 4 },
                { "className": 'actionsColumn desktop', "targets": 5 }
            ],
            language: {
                url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json'
                //TODO: make it depends on current culture not on sdn call
            }
        });


        $('#fuel-cards-datatable')
            .on('click', '.mdi-lock', function () {
                const id = $(this).data('fuel-card-id');
                $.ajax({
                        url: `/FuelCards/Block/${id}`,
                        method: 'PUT',
                        contentType: 'application/json'
                    })
                    .done(function (data) {
                        $.showNotification(data.header, data.message, data.succeed);
                    });
            });


        $('#fuel-cards-datatable')
            .on('click', '.mdi-lock-open-outline', function () {
                const id = $(this).data('fuel-card-id');
                $.ajax({
                        url: `/FuelCards/Unblock/${id}`,
                        method: 'PUT',
                        contentType: 'application/json'
                    })
                    .done(function (data) {
                        $.showNotification(data.header, data.message, data.succeed);
                    });
            });


        $('#fuel-cards-datatable')
            .on('click', '.mdi-delete', function () {
                const id = $(this).data('fuel-card-id');
                console.log(id);
                const serial = $(this).data('fuel-card-serial');
                $('#delete-fuel-card-button').attr('data-fuel-card-id', id);
                $('#delete-modal-body p #fuel-card-serial-to-delete').text(serial);
            });


        $('#delete-fuel-card-button').on('click',
            function () {
                const fuelCardIdToDelete = $(this).data('fuel-card-id');
                $.ajax({
                        url: `/FuelCards/Delete/${fuelCardIdToDelete}`,
                        method: 'DELETE',
                        contentType: 'application/json'
                    })
                    .done(function (data) {
                        $('#delete-modal').modal('hide');
                        $.showNotification(data.header, data.message, data.succeed);
                    });
            });
    };

    return {
        init: init
    };

})();
